import React from 'react';
import SocialProviderTile from '../../components/SocialProviders/SocialProviderTile';
import appSyncClient from '../../appsync/client';
import listSocialProvidersByRequest from '../../appsync/queries/ListSocialProvidersByRequest';
import providersConfig from './providersConfig';
import { EmbeddableConfigContext, contextExistsInStorage, clearSessionStorage } from '../../config/EmbeddableContext';
import Text from '../../components/Text';
import Loader from '../../components/Loader';

import './style.scss';

class SocialProvidersList extends React.Component {
  FILTER_TYPES = {
    ALL: 'all',
    SOCIAL: 'social',
    FINANCIAL: 'financial',
    OTHER: 'other',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      syncInitiated: false,
      providers: [],
      selectedFilter: this.FILTER_TYPES.ALL,
      connectedProviders: [],
      isRedirectedFromStandalone: false,
      restoringContext: false,
    };
    this.filterProviders = this.filterProviders.bind(this);
  }

  componentDidMount() {
    if (
      this.props.location
      && this.props.location.state
      && this.props.location.state.scoringRequest
    ) {
      const { requestId } = this.props.location.state.scoringRequest;
      if (requestId) this.syncScoringRequestSocialProviders(requestId);

      if (contextExistsInStorage()) this.setState({ restoringContext: true });
    }
  }

  componentWillUnmount() {
    clearSessionStorage();
  }

  filterIsHighlighted = (currentFilter) => (this.state.selectedFilter === currentFilter
    ? 'button activeSocialButton'
    : 'button socialButton'
  );

  syncScoringRequestSocialProviders(requestId) {
    this.setState({ syncInitiated: true });
    appSyncClient
      .query({
        query: listSocialProvidersByRequest(requestId),
        fetchPolicy: 'network-only',
      })
      .then((results) => {
        const nextState = { loading: false, providers: providersConfig };
        if (results.data && results.data.listSocialProvidersByRequest) {
          nextState.connectedProviders = results.data.listSocialProvidersByRequest;
        }
        this.setState(nextState);
      })
      .catch((error) => {
        console.error(error); // eslint-disable-line no-console
        this.setState({ loading: false });
      });
  }

  filterProviders(type) {
    const filteredProviders = type === this.FILTER_TYPES.ALL
      ? providersConfig
      : providersConfig.filter((x) => x.type === type);
    this.setState({ providers: filteredProviders, selectedFilter: type });
  }

  findProfile(connectionName) {
    return this.state.connectedProviders
      .find((c) => c.provider.toLowerCase() === connectionName.toLowerCase());
  }

  render() {
    return (
      <EmbeddableConfigContext.Consumer>
        {(embeddedContext) => {
          const {
            isRedirectedFromStandalone,
            loading,
            providers,
            syncInitiated,
            restoringContext,
            scoringRequest: scoringRequestFromContext,
          } = this.state;

          const scoringRequest = scoringRequestFromContext
            || this.props.location.state.scoringRequest;

          const {
            enabledFeatures,
            restoreContextFromSessionStorage,
            saveContextToSessionStorage,
          } = embeddedContext;

          if (!isRedirectedFromStandalone && enabledFeatures.tswebEnabled) {
            this.setState({
              isRedirectedFromStandalone: true,
            });
            return null;
          }

          if (isRedirectedFromStandalone && !enabledFeatures.tswebSocial) {
            this.props.onNextStep(this.props.history, this.props.location.state);
            return null;
          }

          if (isRedirectedFromStandalone && !syncInitiated) {
            this.syncScoringRequestSocialProviders(scoringRequest.requestId);
            saveContextToSessionStorage();
          }

          if (restoringContext) {
            restoreContextFromSessionStorage();
            this.setState({ restoringContext: false });
            return null;
          }

          if (loading) return (<Loader />);

          const providerComponents = providers.map((provider) => {
            const profile = this.findProfile(provider.connectionName);
            return (
              <SocialProviderTile
                key={provider.connectionName}
                scoringRequest={scoringRequest}
                provider={provider}
                history={this.props.history}
                connected={!!profile}
                name={profile ? profile.name : null}
                email={profile ? profile.email : null}
                photoUrl={profile ? profile.photoUrl : null}
                createdAt={profile ? profile.createdAt : null}
              />
            );
          });

          const onNextButtonClicked = () => {
            this.props.onNextStep(this.props.history, this.props.location.state);
          };

          return (
            <section className="socialProvidersWrapper">
              <div className="socialHeader">
                <button
                  type="button"
                  onClick={() => this.filterProviders(this.FILTER_TYPES.ALL)}
                  className={this.filterIsHighlighted(this.FILTER_TYPES.ALL)}
                >
                  All
                </button>
                <button
                  type="button"
                  onClick={() => this.filterProviders(this.FILTER_TYPES.SOCIAL)}
                  className={this.filterIsHighlighted(this.FILTER_TYPES.SOCIAL)}
                >
                  Social
                </button>
                <button
                  type="button"
                  onClick={() => this.filterProviders(this.FILTER_TYPES.FINANCIAL)}
                  className={this.filterIsHighlighted(this.FILTER_TYPES.FINANCIAL)}
                >
                  Financial
                </button>
                <button
                  type="button"
                  onClick={() => this.filterProviders(this.FILTER_TYPES.OTHER)}
                  className={this.filterIsHighlighted(this.FILTER_TYPES.OTHER)}
                >
                  Other
                </button>
              </div>
              <div>
                <div className="providers">
                  { providerComponents }
                </div>
              </div>
              <div className="footer">
                <button type="button" className="btn btn-success" onClick={onNextButtonClicked} data-cy="nextButton">
                  <span>
                    <Text value="Next" />
                  </span>
                </button>
              </div>
            </section>
          );
        }}
      </EmbeddableConfigContext.Consumer>
    );
  }
}

export default SocialProvidersList;
